var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftEntraId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03125 12.9295C4.37613 13.1446 4.94946 13.3837 5.55567 13.3837C6.10767 13.3837 6.62055 13.2237 7.04543 12.9508C7.04543 12.9508 7.04632 12.9508 7.04721 12.9499L8.65163 11.9473V15.5677C8.39741 15.5677 8.14141 15.4983 7.91919 15.3597L4.03125 12.9295Z",
    fill: "#225086"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63269 1.79636L0.966114 9.31626C0.451454 9.89758 0.585675 10.7758 1.25322 11.1927C1.25322 11.1927 3.72074 12.7349 4.03185 12.9295C4.37673 13.1446 4.95006 13.3838 5.55627 13.3838C6.10826 13.3838 6.62115 13.2238 7.04603 12.9509C7.04603 12.9509 7.04692 12.9509 7.04781 12.95L8.65223 11.9473L4.77317 9.52248L8.65312 5.14565V1.3457C8.27623 1.3457 7.89935 1.49592 7.63269 1.79636Z",
    fill: "#66DDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77344 9.52331L4.81966 9.55176L8.65249 11.9482H8.65338V5.14737L8.65249 5.14648L4.77344 9.52331Z",
    fill: "#CBF8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0524 11.1923C16.72 10.7754 16.8542 9.89719 16.3395 9.31586L11.9654 4.38171C11.6125 4.21727 11.2169 4.12305 10.7983 4.12305C9.97606 4.12305 9.24096 4.47771 8.75207 5.03503L8.65519 5.14437L12.5342 9.52119L8.6543 11.946V15.5664C8.9094 15.5664 9.16362 15.4971 9.38584 15.3584L16.0524 11.1914V11.1923Z",
    fill: "#074793"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65323 1.3457V5.14565L8.75012 5.03632C9.239 4.47899 9.9741 4.12433 10.7963 4.12433C11.2159 4.12433 11.6105 4.21944 11.9634 4.38299L9.671 1.79725C9.40522 1.49681 9.02834 1.34659 8.65234 1.34659L8.65323 1.3457Z",
    fill: "#0294E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5334 9.52242L8.6543 5.14648V11.9464L12.5334 9.52242Z",
    fill: "#96BCC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftEntraId);
export default __webpack_public_path__ + "static/media/MicrosoftEntraID.df29be1c163d1b60af0e66616d99b123.svg";
export { ForwardRef as ReactComponent };